export default {
  namespace: 'header',
  state: {
    headerMsg: {}
  }
}
